import { format } from "date-fns";

//Model property
export const FORMs = {
  PROPERTY: {
    id: null,
    owner_id: null,
    // --'Casa','Hotel','Departamento','Cabaña','Casa de huéspedes','Excursión'--
    type: "",
    // --'Alojamiento completo', 'Una habitación', 'Una habitación compartida'
    space: "",

    address: "",
    country: "Argentina",
    province: "",
    city: "",
    postal_code: "",
    show_location: false,
    lat: null,
    lon: null,
    coordinates: [],
    floor: "",
    address_line_three: "",
    address_line_four: "",

    bedrooms: 1, //-- Cuartos
    bathrooms: 1, //-- Baños
    beds: 1, //-- CAMAS
    travellers: 1, //-- Viajeros

    price: 0.0,
    status: "activo",
    created_at: "",

    SERVICES: [],
    CHECKIN: {
      id: null,
      //--'flexible'--
      name: "Sin finalizacion",
      time: null,
      porperty_id: null,
      created_at: "",
    },
    CHECKOUT: {
      id: "",
      time: null,
      porperty_id: "",
      created_at: "",
    },
    //-- Duracion del viaje --
    min_nights: "2",
    max_nights: "100",
    price_intelligent: "0",

    IMAGES: [],

    FEES: [
      {
        day: null,
        limit_day: null,
        name: "Tarifa de limpieza",
        description: "",
        price: 0.0,
      },
      {
        day: null,
        limit_day: null,
        name: "Tarifa por mascota",
        description: "",
        price: 0.0,
      },
      {
        day: null,
        limit_day: null,
        name: "Tarifa por huésped adicional",
        description: "",
        price: 0.0,
      },
    ],

    DESCRIPTION_PROPERTY: [],
    title: "",
    description: "",

    PROMOTIONs: [],

    REVIEWS: [],
    PRICES: []
  },

  SERVICES: {
    id: "",
    //--'Wifi', 'Pileta', 'Televisor', 'Estacionamiento', 'Cocina', 'Refrigerador', 'Ropa de cama', 'Perchas', 'Espacio para guardar ropa',
    //--'Almuerzo', 'Desayuno', 'Merienda', 'Bebidas', 'Traslados', 'Guía profesional'
    name: "",
    porperty_id: "",
    excursion_id: "",
    created_at: "",
  },
  CHECKIN: {
    id: null,
    //--'flexible'--
    name: "Sin finalizacion",
    time: null,
    porperty_id: null,
    created_at: "",
  },
  CHECKOUT: {
    id: "",
    time: null,
    porperty_id: "",
    created_at: "",
  },
  IMAGES: {
    id: null,
    url: "",
    file: "",
    imagetable_type: "",
    imagetable_id: null,
    created_at: "",
  },
  DESCRIPTION_PROPERTY: {
    id: "",
    //--'Tranquilo', 'Único', 'Familiar', 'Elegante', 'Central', 'Espacioso'--
    name: "",
    porperty_id: "",
    created_at: "",
  },
  PROMOTIONs: {
    id: "",
    name: "",
    description: "",
    discount: "",
    porperty_id: "",
    created_at: "",
  },
  REVIEWS: {
    id: "",
    user_id: "",
    property_id: "",
    description: "",
    state: "",
    created_at: "",
  },

  /*Excursiones*/

  EXCURSION: {
    id: null,
    owner_id: null,
    slug: "",

    title: "",
    description: "",
    description_long: "",
    space: "",

    start_date: format(new Date(), 'yyyy-M-dd').toString(),
    regular_time: "",
    //'Flexible'--
    type_time: "",
    duration: 2,

    price: 0.0,
    status: 'activo',
    DESCRIPTION_EXCURSION: [],
    ACTIVITIES: [],
    AMENITIES: [],
    IMAGES: []
  },

  DESCRIPTION_EXCURSION: {
    id: "",
    //--'Tranquilo', 'Único', 'Familiar', 'Elegante', 'Central', 'Espacioso'--
    name: "",
    excursion_id: "",
    created_at: "",
  },

  ACTIVITIES: {
    id: "",
    // 'Excursiones de dia', 'Tour dias completos', 'Tours gastronómicos', 'Estacionamiento', 'Cocina', 'Refrigerador', 'Ropa de cama', 'Perchas', 'Espacio para guardar ropa'
    name: "",
    excursion_id: "",
    created_at: "",
  },

  AMENITIES: {
    id: "",
    // 'Cancelación gratis', 'Actividades en español', 'Accesible a sillas de ruedas', 'Admite mascotas', 'Recogida en alojamiento', 'Servicio privado' --
    name: "",
    excursion_id: "",
    created_at: "",
  },
};
